var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { AppProvider } from "./AppProvider";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ScriptPage } from "./pages/scriptPage/ScriptPage";
import { ScriptsSearchPage } from "./pages/ScriptsSearchPage";
export function createRealmsbaseRoutes(rootPath) {
    return [
        {
            path: rootPath + "/register",
            element: (_jsx(AppProvider, __assign({ rootPath: rootPath }, { children: _jsx(RegisterPage, {}) }))),
        },
        {
            path: rootPath + "/login",
            element: (_jsx(AppProvider, __assign({ rootPath: rootPath }, { children: _jsx(LoginPage, {}) }))),
        },
        {
            path: rootPath + "/scripts/search",
            element: (_jsx(AppProvider, __assign({ rootPath: rootPath }, { children: _jsx(ScriptsSearchPage, {}) }))),
        },
        {
            path: rootPath + "/script/:scriptId",
            element: (_jsx(AppProvider, __assign({ rootPath: rootPath }, { children: _jsx(ScriptPage, {}) }))),
        },
        {
            path: rootPath + "",
            element: _jsx(Navigate, { to: rootPath + "login" }),
        },
    ];
}
